import { makeStyles, css } from '@conexasaude/hero'

import { typoMixin } from '@/styles/mixins/typo-mixin'

const useStyles = makeStyles({
  professionalAvatarContainer: ({ borderRadius, typography, colors }) => css`
    display: flex;
    align-items: center;

    img {
      width: 48px;
      height: 48px;
      object-fit: cover;
      border-radius: ${borderRadius.circular};
    }

    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 16px;

      h5 {
        ${typoMixin({ typography }, 'h5')}
        color: ${colors.neutral[900]};
      }

      span {
        ${typoMixin({ typography }, 'body2')}
        color: ${colors.primary[500]};
      }
    }
  `,

  professionalAvatarImgWrapper: ({ colors }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: ${colors.neutral[100]};
  `,
})

export { useStyles }
